<mat-form-field>
  <mat-chip-list #filterList>
    <mat-chip *ngFor="let filter of filters" [selectable]="true"
              [removable]="true" (removed)="removeFilter(filter)">
      {{filter}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
  <input [matChipInputFor]="filterList" placeholder="Filter"
         [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
         [matChipInputAddOnBlur]="true"
         (matChipInputTokenEnd)="addFilter($event)">
</mat-form-field>
